"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientStatusBadge = exports.ClientLogo = void 0;
var client_logo_1 = require("./client-logo");
Object.defineProperty(exports, "ClientLogo", { enumerable: true, get: function () { return client_logo_1.ClientLogo; } });
var client_status_badge_1 = require("./client-status-badge");
Object.defineProperty(exports, "ClientStatusBadge", { enumerable: true, get: function () { return client_status_badge_1.ClientStatusBadge; } });
